import { Section, Eyebrow } from "./Section"

const STEPS = [
  { name: "Position", body: "Clarify the business, offer, audience, and authority angle." },
  { name: "Map", body: "Identify the guest ecosystem around future clients, partners, and referral sources." },
  { name: "Prepare", body: "Create guest briefs, outreach angles, interview questions, and episode direction." },
  { name: "Produce", body: "Record, edit, publish, and package each weekly video episode professionally." },
  { name: "Multiply", body: "Turn each conversation into clips, posts, emails, and follow-up assets." },
  { name: "Review", body: "Track content momentum, relationship opportunities, and strategic next steps." },
]

export function GrowthLoop() {
  return (
    <Section id="growth-loop" className="bg-surface">
      <div className="max-w-2xl">
        <Eyebrow>The method</Eyebrow>
        <h2 className="display-2 mt-4">The FullCast Growth Loop</h2>
        <p className="mt-5 text-lg text-ink-body">
          A podcast becomes more valuable when every conversation has a reason,
          every episode has a purpose, and every asset supports the bigger
          relationship strategy.
        </p>
      </div>

      <ol className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {STEPS.map((step, i) => (
          <li
            key={step.name}
            className="rounded-lg border border-hairline bg-page p-6"
          >
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-faded font-display text-sm font-semibold text-accent-display">
                {i + 1}
              </span>
              <h3>{step.name}</h3>
            </div>
            <p className="mt-3 text-sm text-ink-muted">{step.body}</p>
          </li>
        ))}
      </ol>

      <p className="mt-8 text-sm text-ink-muted">
        Then the loop begins again — each cycle compounding your authority and
        relationships.
      </p>
    </Section>
  )
}
